import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as bulkFunctionalUsage from '../../bulk-functional-usage'
import type { Plugin } from '../plugin'

/**
 * Loads record warnings when functional usage is bulk updated.
 *
 * The bulk update does not go through the record's own functional usage
 * plugin, so without this the warnings stay as they were before it ran.
 */
export const loadForCurrentEntityOnBulkFunctionalUsageChange =
  store.effects.create((feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins
      .lookup(bulkFunctionalUsage.Plugin)
      .get()
      .actions.submit.success.observe()
      .pipe(
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from(
              '(effect) load record warnings for current entity on bulk functional usage change',
            )
            .create(),
        ),
      ),
  )
